import React from 'react'
import { BrowserRouter as Router, Route, Switch, } from 'react-router-dom';

import { responseGet, globalSettings, isUndNullEmp, sendMessageCloseCurrentWindowAsync } from '../helpers/settings';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';

//#region Accounts
import ContactMessage from '../views/accounts/ContactMessage';
import ForgotPassword from '../views/accounts/ForgotPassword';
import ForgotPasswordMessage from '../views/accounts/ForgotPasswordMessage';
import Profile from '../views/accounts/Profile';
import RegisterUser from '../views/accounts/RegisterUser';
import RegistrationStatus from '../views/accounts/RegisterStatus';
import VerificationMessage from '../views/accounts/VerificationMessage';
import WelcomeMessage from '../views/accounts/WelcomeMessage';
//#endregion Accounts

//#region apartments
import Apartments from '../views/apartments/Apartments';
import ApartmentEdit from '../views/apartments/ApartmentEdit';
import ApartmentDetails from '../views/apartments/ApartmentDetails';
import ApartmentReceipts from '../views/apartments/ApartmentReceipts';
//#endregion apartments

//#region banks
import Banks from '../views/banks/Banks';
//#endregion banks

//#region bank accounts
import BankAccounts from '../views/bankAccounts/BankAccounts';
//#endregion bank accounts

//#region bank account movements
import BankAccountMovementsPrint from '../views/bankAccounts/BankAccountMovementsPrint';
import BankAccountMovements from '../views/bankAccounts/BankAccountMovements';
//#endregion bank account movements

//#region buildings
import BuildingDocuments from '../views/buildings/BuildingDocuments';
import BuildingEdit from '../views/buildings/BuildingEdit';
import BuildingDetails from '../views/buildings/BuildingDetails';
import Buildings from '../views/buildings/Buildings';
//#endregion buildings

//#region coins
import Coins from '../views/coins/Coins';
//#endregion coins

//#region collections
import CollectionCashMovements from '../views/collections/CollectionCashMovements';
import ReconcilePayments from '../views/collections/ReconcilePayments';
import CollectionCashes from '../views/collections/CollectionCashes';
//#endregion collections

//#region collection cash movements (tmp)
import CollectionCashMovementsPrint from '../views/collections/CollectionCashMovementsPrint';
//#endregion collection cash movements (tmp)

//#region Condominium board
import CondominiumBoardRoles from '../views/condominuimBoards/CondominiumBoardRoles';
import ElectionDetails from '../views/condominuimBoards/ElectionDetails';
import ElectionEdit from '../views/condominuimBoards/ElectionEdit';
import Elections from '../views/condominuimBoards/Elections';
import ElectionPreviousResultsPrint from '../views/condominuimBoards/ElectionPreviousResultsPrint';
import ElectionResultsPrint from '../views/condominuimBoards/ElectionResultsPrint';
//#endregion Condominium board

//#region countries
import Countries from '../views/countries/Countries';
//#endregion countries

//#region expenses
import Templates from '../views/expenses/Templates';
import Concepts from '../views/expenses/Concepts';
//#endregion expenses

//#region expense concept variation
import ConceptVariationsPrint from '../views/expenses/ConceptVariationsPrint';
//#endregion expense concept variation

//#region Home
import About from '../views/home/About';
import Contact from '../views/home/Contact';
import Home from '../views/home/Home';
import NotFound from '../views/home/NotFound';
import Privacy from '../views/home/Privacy';
//#endregion Home

//#region informative billboard
import InformativeBillboard from '../views/informativeBillboard/InformativeBillboard';
//#endregion informative billboard

//#region Loggins
import Login from '../views/login/Login';
//#endregion Loggins

//#region Main
//import Menu from '../views/main/Menu';
import Header from '../views/main/Header';
import Footer from '../views/main/Footer';
//#endregion Main

//#region People types
import PeopleTypes from '../views/peopleTypes/PeopleTypes';
//#endregion People types

//#region Payment methods
import PaymentMethods from '../views/paymentMethods/PaymentMethods';
//#endregion Payment methods

//#region purchases
import Purchases from '../views/purchases/Purchases';
import PurchaseAdd from '../views/purchases/PurchaseAdd';
import PurchaseEdit from '../views/purchases/PurchaseEdit';
import PurchaseDetail from '../views/purchases/PurchaseDetail';
import PurchasePayments from '../views/purchases/PurchasePayments';
//#endregion purchases

//#region receipts
import ReceiptGenerate from '../views/receipts/ReceiptGenerate';
import ReceiptPrint from '../views/receipts/ReceiptPrint';
import ReceiptsVariationsPrint from '../views/receipts/ReceiptsVariationsPrint';
//#endregion receipts

//#region reserve common areas
import ReserveCommonAreas from '../views/reserveCommonAreas/ReserveCommonAreas';
//#endregion reserve common areas

//#region roles
import Roles from '../views/roles/Roles';
//#endregion roles

//#region Suppliers
import Suppliers from '../views/suppliers/Suppliers';
import SupplierCurrentBalance from '../views/suppliers/SupplierCurrentBalance';
import SupplierCurrentBalancePrint from '../views/suppliers/SupplierCurrentBalancePrint';
//#endregion Suppliers

//#region taxes
import Taxes from '../views/taxes/Taxes';
//#endregion taxes

//#region
import Users from '../views/users/Users';
//#endregion users

const { backend, reports, } = globalSettings?.app;

export default function AppRouter() {
    //#region initialize
    const currentLocation = window?.location?.pathname;
    const showSection = {
        header: true,
        footer: true,
    };
    //#endregion initialize

    //#region methods
    const checkIdShowHeaderFooterAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'checkIdShowHeaderFooterAsync';
        let response = responseGet();
        try {
            //#region variables
            const reportList = [
                `/${reports?.receiptPrint}`,
                `/${reports?.collectionCashMovementsPrint}`,
                `/${reports?.bankAccountMovementsPrint}`,
                `/${reports?.expenseConceptVariationsPrint}`,
                `/${reports?.supplierCurrentBalancePrint}`,
                `/${reports?.electionResultsPrint}`,
                `/${reports?.electionPreviousResultsPrint}`,
                `/${reports?.receiptsVariationsPrint}`,
            ];
            //#endregion variables

            //#region methods
            //#region old code
            // reports?.some((detail) => {
            //     if (currentLocation?.indexOf(detail) >= 0) {
            //         showSection.header = false;
            //         showSection.footer = false;
            //         return true;
            //     }
            //     return false;
            // });
            //#endregion old code

            for (let detail of reportList) {
                if (currentLocation?.indexOf(detail) >= 0) {
                    showSection.header = false;
                    showSection.footer = false;
                    return;
                }
            };
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: {},
                isLogout: false,
                languageId: 'en',
                subMethod: currentMethod,
            });
        }
    }

    checkIdShowHeaderFooterAsync({ subMethod: 'form - onLoad' });
    //#endregion methods

    return (
        <Router>
            {/* Preloader */}
            <div className='preloader flex-column justify-content-center align-items-center'>
                <img className='animation__shake' src={globalSettings?.images?.appLogo} alt='AdminLTELogo' height={60} width={60} />
            </div>

            {showSection.header ? <Header /> : <></>}
            {/* <Menu/> */}

            <Switch>

                {/*Accounts*/}
                <PrivateRoute exact path={backend?.urlProfile} component={Profile} />
                <Route path={`${backend?.urlContactMessage}/:id`} component={ContactMessage} />
                <Route path={`${backend?.urlForgotPasswordMessage}/:id`} component={ForgotPasswordMessage} />
                <Route path={`${backend?.urlWelcomeMessage}/:id`} component={WelcomeMessage} />
                <Route path={`${backend?.urlVerificationMessage}/:id`} component={VerificationMessage} />

                {/*Apartments*/}
                <PrivateRoute exact path={backend?.urlApartments} component={Apartments} />
                <PrivateRoute path={`${backend?.urlApartmentEdit}/:id`} component={ApartmentEdit} />
                <PrivateRoute path={`${backend?.urlApartmentDetails}/:id`} component={ApartmentDetails} />
                <PrivateRoute exact path={backend?.urlApartmentReceipts} component={ApartmentReceipts} />

                {/*Bank accounts */}
                <PrivateRoute path={`${backend?.urlBankAccountMovements}/:id`} component={BankAccountMovements} />
                <PrivateRoute path={`/${reports?.bankAccountMovementsPrint}/:id`} component={BankAccountMovementsPrint} />

                {/*Buildings*/}
                <PrivateRoute exact path={backend?.urlBuildings} component={Buildings} />
                <PrivateRoute path={`${backend?.urlBuildingEdit}/:id`} component={BuildingEdit} />
                <PrivateRoute path={`${backend?.urlBuildingDetails}/:id`} component={BuildingDetails} />
                <PrivateRoute exact path={`${backend?.urlBuildingDocuments}`} component={BuildingDocuments} />

                {/*Collection*/}
                <PrivateRoute exact path={backend?.urlReconcilePayments} component={ReconcilePayments} />
                <PrivateRoute exact path={backend?.urlCollectionCashes} component={CollectionCashes} />
                <PrivateRoute exact path={backend?.urlCollectionBankAccounts} component={BankAccounts} />
                <PrivateRoute path={`${backend?.urlCollectionCashMovements}/:id`} component={CollectionCashMovements} />

                {/*Collection cash movement (tmp)*/}
                <PrivateRoute path={`/${reports?.collectionCashMovementsPrint}/:id`} component={CollectionCashMovementsPrint} />

                { /* Condominium board */}
                <PrivateRoute exact path={backend?.urlCondominiumBoardRoles} component={CondominiumBoardRoles} />
                <PrivateRoute exact path={backend?.urlCondominiumBoardElections} component={Elections} />
                <PrivateRoute path={`${backend?.urlCondominiumBoardElectionEdit}/:id`} component={ElectionEdit} />
                <PrivateRoute path={`${backend?.urlCondominiumBoardElectionDetails}/:id`} component={ElectionDetails} />
                <PrivateRoute path={`/${reports?.electionResultsPrint}/:id`} component={ElectionResultsPrint} />
                <PrivateRoute path={`/${reports?.electionPreviousResultsPrint}/:id`} component={ElectionPreviousResultsPrint} />

                {/*Expenses*/}
                <PrivateRoute exact path={backend?.urlExpenseConcepts} component={Concepts} />
                <PrivateRoute path={`/${reports?.expenseConceptVariationsPrint}/:id`} component={ConceptVariationsPrint} />
                <PrivateRoute exact path={backend?.urlExpenseTemplates} component={Templates} />
                <PrivateRoute exact path={backend?.urlPurchases} component={Purchases} />
                <PrivateRoute path={`${backend?.urlPurchaseAdd}/:id`} component={PurchaseAdd} />
                <PrivateRoute path={`${backend?.urlPurchaseEdit}/:id`} component={PurchaseEdit} />
                <PrivateRoute path={`${backend?.urlPurchaseDetail}/:id`} component={PurchaseDetail} />
                <PrivateRoute path={`${backend?.urlPurchasePayments}/:id`} component={PurchasePayments} />

                {/* Home */}
                <Route exact path='/' component={Home} />
                <Route exact path={backend?.urlHome} component={Home} />
                <Route exact path={backend?.urlAbout} component={About} />
                <Route exact path={backend?.urlContact} component={Contact} />
                <Route exact path={backend?.urlPrivacy} component={Privacy} />

                {/*Informative billboard*/}
                <PrivateRoute exact path={backend?.urlInformativeBillboards} component={InformativeBillboard} />

                {/*Login*/}
                <PublicRoute exact path={backend?.urlLogin} component={Login} />
                <PublicRoute exact path={backend?.urlForgotPassword} component={ForgotPassword} />
                <PublicRoute exact path={backend?.urlUserRegister} component={RegisterUser} />
                <PublicRoute exact path={backend?.urlRegisterStatus} component={RegistrationStatus} />

                {/*Receipts*/}
                <PrivateRoute exact path={backend?.urlReceiptGenerate} component={ReceiptGenerate} />
                <PrivateRoute path={`/${reports?.receiptPrint}/:id`} component={ReceiptPrint} />
                <PrivateRoute path={`/${reports?.receiptsVariationsPrint}/:id`} component={ReceiptsVariationsPrint} />

                {/*Reserver common areas*/}
                <PrivateRoute exact path={backend?.urlReserveCommonAreas} component={ReserveCommonAreas} />

                {/*Settings*/}
                <PrivateRoute exact path={backend?.urlCountries} component={Countries} />
                <PrivateRoute exact path={backend?.urlCoins} component={Coins} />
                <PrivateRoute exact path={backend?.urlBanks} component={Banks} />
                <PrivateRoute exact path={backend?.urlPaymentMethods} component={PaymentMethods} />
                <PrivateRoute exact path={backend?.urlTaxes} component={Taxes} />
                <PrivateRoute exact path={backend?.urlPeopleTypes} component={PeopleTypes} />
                <PrivateRoute exact path={backend?.urlRoles} component={Roles} />
                <PrivateRoute exact path={backend?.urlUsers} component={Users} />

                {/*Suppliers*/}
                <PrivateRoute exact path={backend?.urlSuppliers} component={Suppliers} />
                <PrivateRoute path={`${backend?.urlSupplierCurrentBalance}/:id`} component={SupplierCurrentBalance} />
                <PrivateRoute path={`/${reports?.supplierCurrentBalancePrint}/:id`} component={SupplierCurrentBalancePrint} />

                {/* Not found */}
                <Route path='*' component={NotFound} />

            </Switch>

            {showSection.footer ? <Footer /> : <></>}

        </Router>
    )
}